// src/pages/Branches.jsx (Careers)
import PageBanner from '../components/ui/PageBanner';
import { JOBS } from '../data/careers';
import './Branches.css';

export default function Branches({ setPage }) {
  return (
    <>
      <PageBanner title="Careers" crumbs={['Home', 'Careers']} />

      <section className="section">
        <div className="section-inner">
          <div className="branches__header">
            <p className="section-label">Current Openings</p>
            <h3 className="section-title">Join Our Team</h3>
            <p className="section-text">Explore our available positions and take the next step in your career</p>
          </div>

          <div className="career__cards">
            {JOBS.map((job) => (
              <button
                key={job.id}
                type="button"
                className="career__card card"
                onClick={() => setPage('career-details', { params: { jobId: job.id } })}
              >
                <div className="career__card-title">{job.title}</div>
                <div className="career__card-meta">
                  <span>{job.department}</span>
                  <span>•</span>
                  <span>{job.location}</span>
                  <span>•</span>
                  <span>{job.type}</span>
                </div>
                <p className="career__card-text">{job.overview}</p>
                <div className="career__card-cta">
                  <span className="btn-outline">View Details</span>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}